<template>
	<layout-admin-auto-loading class="admin-watch-list" :loader="getDevices" :loading="loading" :finished="finished" :error="error">
		<div slot="breadcrumbs"><admin-breadcrumbs :breadcrumbs="breadcrumbs"/></div>
		<div slot="header" class="slot">
			<h1>{{ title }}</h1>
			<button-icon-text :to="{ name: 'AdminDeviceAdd' }" icon="plus-w" class="plus btn-add">Add Device</button-icon-text>
		</div>
		<div slot="body" v-if="!error">
			<admin-data-table :finished="finished" :table_columns="table_columns" :table_rows="table_rows"/>
		</div>
	</layout-admin-auto-loading>
</template>

<script>
import LayoutAdminAutoLoading from '../LayoutAdminAutoLoading'
import AdminBreadcrumbs from '../AdminBreadcrumbs'
import AdminDataTable from '../AdminDataTable'
export default {
	components: {
		LayoutAdminAutoLoading,
		AdminBreadcrumbs,
		AdminDataTable
	},
	data () {
		return {
			title: 'Device Whitelist',
			loading: false,
			error: null,
			data: [],
			finished: false,
			limit: 20,
			table_columns: [
				{
					label: '#',
					field: 'id',
					width: '75px'
				},
				{
					label: 'IMEI',
					field: 'imei',
					width: '1fr'
				},
				{
					label: '',
					width: '75px'
				}
			]
		}
	},
	computed: {
		breadcrumbs () {
			return [
				{
					title: this.title
				}
			]
		},
		offset () {
			return this.data.length
		},
		table_rows () {
			return this.data.map(row => {
				return {
					columns: [
						{ field: 'id', value: row.id },
						{ field: 'imei', value: row.imei },
						{
							field: 'operation',
							type: 'operation',
							value: { title: 'Edit', to: { name: 'AdminDeviceEdit', params: { device_id: row.id, data: row } } }
						}
					]
				}
			})
		}
	},
	methods: {
		getDevices () {
			this.loading = true
			this.$api.devices.admin.whitelist.getAll(this, this.offset, this.limit)
				.then(response => {
					this.$log.info('admin', 'devices.admin.whitelist.getAll OK', response)()
					if (response.body.length) {
						this.data = this.data.concat(response.body)
					}
					if (!response.body.length || response.body.length < this.limit) {
						this.finished = true
					}
				}).catch(errors => {
					this.$log.error('admin', 'devices.admin.whitelist.getAll ERROR', errors)()
					this.error = errors
				}).finally(() => {
					this.loading = false
				})
		}
	},
	beforeCreate () {
		this.$title('Device Whitelist')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/devices/DeviceList.vue